// Permission Codes as stored in [EFUP].[PERMSSN].[PERMSSN_CD]
//If any of these are tied to a feature flag with a many to many Has - please update util/FeatureFlagUtility featureFlagPermissions
export const G_ADMIN_USER = 'G_ADMIN_USER';
export const G_AD_HOC_PAYMENT = 'G_AD_HOC_PAYMENT';
export const G_EXPORT_TRANSACTION = 'G_EXPORT_TRANSACTION';
export const DASH_VENDOR_TILES = 'DASH_VENDOR_TILES';
export const PAY_OVERVIEW_CHANGE_STATUS = 'PAY_OVERVIEW_CHANGE_STATUS';
export const PAY_OVERVIEW_STOP_PAYMENT = 'PAY_OVERVIEW_STOP_PAYMENT';
export const PAY_NOTES_ADD_NOTES = 'PAY_NOTES_ADD_NOTES';
export const PAY_VIEW_DOCUMENTS = 'PAY_VIEW_DOCUMENTS';
export const PAY_DOCS_DOWNLOAD_DOCUMENTS = 'PAY_DOCS_DOWNLOAD_DOCUMENTS';
export const PAY_ACTIVITY_ADD_ACTIVITY = 'PAY_ACTIVITY_ADD_ACTIVITY';
export const U_VIEW_USERS = 'U_VIEW_USERS';
export const U_USER_ADMIN = 'U_USER_ADMIN';
export const ROLE_INTERNAL_U_USER_ADMIN = "ROLE_INTERNAL_U_USER_ADMIN";
export const REGISTER_COMPANIES = "REGISTER_COMPANIES";

export const PermissionTypes = [
    G_AD_HOC_PAYMENT,
    G_EXPORT_TRANSACTION,
    DASH_VENDOR_TILES,
    PAY_OVERVIEW_CHANGE_STATUS,
    PAY_OVERVIEW_STOP_PAYMENT,
    PAY_NOTES_ADD_NOTES,
    PAY_VIEW_DOCUMENTS,
    PAY_DOCS_DOWNLOAD_DOCUMENTS,
    PAY_ACTIVITY_ADD_ACTIVITY,
    U_VIEW_USERS,
    U_USER_ADMIN,
    REGISTER_COMPANIES
]

export const UserPermissionTypes = [
    G_EXPORT_TRANSACTION,
    U_VIEW_USERS,
    PAY_OVERVIEW_STOP_PAYMENT,
    U_USER_ADMIN
];

export const CompanyRolePermissionTypes = [
    G_EXPORT_TRANSACTION,
    U_VIEW_USERS,
    PAY_OVERVIEW_STOP_PAYMENT
];

export const InternalRolePermissionTypes = [
    G_EXPORT_TRANSACTION,
    PAY_OVERVIEW_STOP_PAYMENT,
    PAY_NOTES_ADD_NOTES,
    U_VIEW_USERS,
    REGISTER_COMPANIES
];
